@if (scenario) {
  <mat-expansion-panel class="detail-card" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>{{scenario.scenario.code | codeFormat: codeTableScenarios | async}}</mat-panel-title>
      <mat-panel-description class="walk-toggle-description">
        <span class="walk-toggle"
              [class.on]="showWalkToProceeds"
              (click)="toggleWalkToProceeds(); $event.stopPropagation()"
              (keydown.enter)="toggleWalkToProceeds(); $event.stopPropagation()"
              tabindex="0"
              role="switch"
              [attr.aria-checked]="showWalkToProceeds">
          <span class="walk-switch"></span>
          <span>{{ showWalkToProceeds ? "Hide GP proceeds waterfall" : "Show GP proceeds waterfall" }}</span>
        </span>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="key-value-pair-section">
      <div class="key-value-pair-column">
        <div>
          <div class="key-value-pair">
            <div class="key-value-item">Probability</div>
            <div class="key-value-item">{{scenario.probability | traceableFormat}}</div>
          </div>
          <div class="key-value-pair">
            <div class="key-value-item">Exit EV/{{earningBase.code | codeFormat: codeTableEarningBase | async}} Multiple</div>
            <div class="key-value-item">{{scenario.enterpriseValueOverEarningBaseMultiple | traceableFormat}}</div>
          </div>
          <div class="key-value-pair">
            <div class="key-value-item">NAV Multiple</div>
            <div class="key-value-item">{{scenario.navMultiple | traceableFormat}}</div>
          </div>
          <div class="key-value-pair">
            <div class="key-value-item">Primary TVPI</div>
            <div class="key-value-item">{{scenario.primaryTVPI | traceableFormat}}</div>
          </div>
          <div class="key-value-pair">
            <div class="key-value-item">Secondary TVPI</div>
            <div class="key-value-item">{{scenario.secondaryTVPI | traceableFormat}}</div>
          </div>
          <div class="key-value-pair">
            <div class="key-value-item">Secondary IRR</div>
            <div class="key-value-item">{{scenario.secondaryIRR | traceableFormat}}</div>
          </div>
        </div>
      </div>
      <div class="key-value-pair-column">
        <div>
          <div class="key-value-pair">
            <div class="key-value-item">Revenues Uplift</div>
            <div class="key-value-item">{{scenario.revenuesUplift | traceableFormat}}</div>
          </div>
          @if (earningBase.code) {
            <div class="key-value-pair">
              <div class="key-value-item">{{earningBase.code | codeFormat: codeTableEarningBase | async}} Uplift</div>
              <div class="key-value-item">{{scenario.earningBaseUplift | traceableFormat}}</div>
            </div>
          }
          <div class="key-value-pair">
            <div class="key-value-item">Debt Repayment</div>
            <div class="key-value-item">{{scenario.debtRepayment | traceableFormat}}</div>
          </div>
          <div class="key-value-pair">
            <div class="key-value-item">Revenues CAGR</div>
            <div class="key-value-item">{{scenario.revenuesCAGR | traceableFormat}}</div>
          </div>
          @if (earningBase.code) {
            <div class="key-value-pair">
              <div class="key-value-item">{{earningBase.code | codeFormat: codeTableEarningBase | async}} CAGR</div>
              <div class="key-value-item">{{scenario.earningBaseCAGR | traceableFormat}}</div>
            </div>
          }
          <div class="key-value-pair">
            <div class="key-value-item">Debt Repayment Capacity</div>
            <div class="key-value-item">{{scenario.debtRepaymentCapacity | traceableFormat}}</div>
          </div>
        </div>
      </div>
      <div class="key-value-pair-column">
        <div>
          <div class="key-value-pair">
            <form [formGroup]="cashflowForm">
              <table class="key-value-item" [dataSource]="scenario.cashflows" formArrayName="cashflows" mat-table>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef class="no-bold">
                    @if (fundCurrencyIso$ | async; as fundCurrencyIso) {
                      <valumize-currency-badge
                        kind="FUND"
                        [iso]="fundCurrencyIso"
                        size="compact"
                        tooltip="Exit proceeds are in the fund's reporting currency">
                      </valumize-currency-badge>
                    } @else {
                      Fund Currency
                    }
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div>{{element.cashflowType.code | codeFormat: codeTableCashflowType | async}} {{element.date | traceableFormat}}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>Total</td>
                </ng-container>
                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef>Amount</th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    @if (cashflowsAreEditable && isEditableCashflow(element)) {
                      <input matInput
                        type="number"
                        [value]="element.amount | traceableFormat"
                        (change)="onFormValueChange($event, element, i)">
                    } @else {
                      <div>{{element.amount | traceableFormat}}</div>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef>{{scenario.totalCashflow | traceableFormat}}</td>
                </ng-container>
                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef>
                    @if (!cashflowsAreEditable) {
                      @if (editableCashflowsExist(scenario.cashflows)) {
                        <button
                          (click)="editCashflows(scenario.scenario.code)"
                          [disabled]="(isEditDisabled$ | async)!"
                          color="primary"
                          data-test="edit-button"
                          mat-icon-button>
                          <mat-icon class="icon-display">edit</mat-icon>
                        </button>
                      }
                    } @else {
                      <div style="display: flex">
                        <button (click)="saveCashflows()"
                          [disabled]="cashflowForm.invalid"
                          color="primary"
                          data-test="save-button"
                          mat-icon-button>
                          <mat-icon class="icon-display">save</mat-icon>
                        </button>
                        <button (click)="cancelCashflows(scenario.scenario.code)"
                          color="primary"
                          data-test="cancel-button"
                          mat-icon-button>
                          <mat-icon class="icon-display">cancel</mat-icon>
                        </button>
                      </div>
                    }
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (cashflowsAreEditable && isEditableCashflow(element)) {
                      <button
                        color="primary"
                        (click)="deleteCashflows(element)"
                        mat-icon-button>
                        <mat-icon class="icon-display">delete</mat-icon>
                      </button>
                    } @else {
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="cashflowTableColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: cashflowTableColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="cashflowTableColumns" class="row-important row-top-border"></tr>
              </table>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="fov-and-quick-forecast">
      <valumize-asset-financial-operational-valuation-table
        [assetId]="assetId"
        [assetValuationId]="assetValuationId"
        [scenario]="scenario"
        [isEditable]="recordsAreEditable"
        [isEditDisabled]="isEditDisabled$ | async"
        [exitDateAssumption]="selectedExitDateAssumptionOperational$ | async"
        [historyBase]="historyBase"
        [quickForecastOpen]="quickForecastOpen"
        [showWalkToProceeds]="showWalkToProceeds"
        (quickForecastToggle)="toggleQuickForecast()">
      </valumize-asset-financial-operational-valuation-table>
      @if (quickForecastOpen && recordsAreEditable && assetId && assetValuationId && scenario.id && earningBase.code) {
        <valumize-quick-forecast
          [assetId]="assetId"
          [assetValuationId]="assetValuationId"
          [scenarioId]="scenario.id"
          [scenarioType]="$any(scenario.scenario.code)"
          [earningBase]="earningBase.code"
          [forecastRecords]="(forecastRecords$ | async) ?? []"
          (closed)="closeQuickForecast()">
        </valumize-quick-forecast>
      }
    </div>
  </mat-expansion-panel>
}
